import * as tokens from '@utmost.co/utmost-design-tokens';

export function setAppTheme(type: string | undefined = 'theme-light'): void {
  const targetType = ensureThemeTypeIsCorrect(type);

  if (document.querySelectorAll(`head link[href*="${type}"]`).length === 0 && targetType) {
    tokens.setAppTheme('#theme-css', targetType);
  }
}

const themes = ['themeCustom', 'themeDark', 'themeHighContrast', 'themeLight'] as const;
type ThemeName = (typeof themes)[number];
function ensureThemeTypeIsCorrect(type: string): ThemeName | undefined {
  const targetType = type.startsWith('theme') ? type : `theme${type.charAt(0).toUpperCase()}${type.slice(1)}`;

  return themes.includes(targetType as ThemeName) ? (targetType as ThemeName) : undefined;
}
